import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-deal-info",
  templateUrl: "./deal-info.component.html",
  styleUrls: ["./deal-info.component.css"],
})
export class DealInfoComponent implements OnInit {
  @Input() merchantInfo!: any;

  showLogo = true;

  constructor() {}

  ngOnInit(): void {}

  changeMerchantLogo(path: string): boolean {
    if (path == "" || !path || path.includes("online.payx.am")) return false;
    return true;
  }

  correctImg() {
    this.merchantInfo.logo = (this.merchantInfo.logo as string).replace(
      "https://arcalink.arca.amimages",
      "https://arcalink.arca.am/images"
    );

    return this.merchantInfo.logo;
  }

  evaluateLogo() {
    const logo = this.merchantInfo?.logo;
    this.showLogo = !!logo && logo !== "" && !logo.includes("online.payx.am");
  }

  onError() {
    this.showLogo = false;
  }
}
